/**
 * Chatwoot Core
 * Core base classes and utilities for Chatwoot services
 */

export * from "./base-chatwoot-service";

